import { AccordionDetails, Typography, Stack, Accordion, AccordionSummary, Box, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Chip } from "@mui/material"
import { parseDbStringSeconds, secondsToTimeString } from "../../../../../utils/date"
import { useState } from "react"
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

export default function AccordionDetailsAverageTime({ unidadesMap, metricKey, config }) {
    const [expanded, setExpanded] = useState(false)

    const handleChange = (panel) => (__, isExpanded) => {
        setExpanded(isExpanded ? panel : false)
    }

    const calculateSingleOrderTime = (order) => {
        if (!metricKey) return 0

        const parsed = parseDbStringSeconds(order[metricKey])

        if (parsed !== null && parsed > 0) return parsed

        let startStr, endStr

        switch (metricKey) {
            case 'tempoConfirmacao':
                startStr = order.dataPedido || order.data_pedido
                endStr = order.dataConfirmacao || order.data_confirmacao
                break
            case 'tempoProducao':
                startStr = order.dataConfirmacao || order.data_confirmacao
                endStr = order.dataSaida || order.data_saida
                break
            case 'tempoEntrega':
                startStr = order.dataSaida || order.data_saida
                endStr = order.dataEntrega || order.data_entrega
                break
            case 'tempoTotal':
                startStr = order.dataPedido || order.data_pedido
                endStr = order.dataEntrega || order.data_entrega
                break
            default:
                return 0
        }

        if (startStr && endStr) {
            const startDate = new Date(startStr)
            const endDate = new Date(endStr)
            const diffSec = (endDate - startDate) / 1000

            return diffSec > 0 ? diffSec : 0
        }

        return 0
    }

    const getDailyAverages = (pedidos) => {
        const groups = {}

        pedidos.forEach(pedido => {
            const time = calculateSingleOrderTime(pedido)

            if (time > 0) {
                const dateObj = new Date(pedido.dataPedido || pedido.data_pedido)
                const dateKey = dateObj.toLocaleDateString('pt-BR')

                if (!groups[dateKey]) {
                    groups[dateKey] = { totalTime: 0, count: 0, rawDate: dateObj }
                }

                groups[dateKey].totalTime += time
                groups[dateKey].count += 1
            }
        })

        return Object.entries(groups)
            .map(([dateString, data]) => ({
                date: dateString,
                avgTime: data.totalTime / data.count,
                count: data.count,
                rawDate: data.rawDate
            }))
            .sort((a, b) => b.rawDate - a.rawDate)
    }

    return (
        <AccordionDetails sx={{ px: 0 }}>
            <Stack spacing={1}>
                {Object.entries(unidadesMap || {}).map(([idUnidade, { unidadeName, pedidos }]) => {
                    const dailyData = getDailyAverages(pedidos)

                    if (dailyData.length === 0) return null

                    return (
                        <Accordion
                            key={idUnidade}
                            expanded={expanded === idUnidade}
                            onChange={handleChange(idUnidade)}
                            sx={{
                                px: 0, "& .MuiAccordionSummary-content": {
                                    width: '100%', display: 'flex', flexDirection: 'column'
                                }
                            }}
                        >
                            <AccordionSummary expandIcon={expanded === idUnidade ? <ExpandLessIcon /> : <ExpandMoreIcon />}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                                    <Typography variant="h6">{unidadeName}</Typography>
                                    <Box>
                                        <Typography variant="body2" sx={{ mr: 1, textAlign: 'right' }}>
                                            Dias c/ dados: <strong>{dailyData.length}</strong>
                                        </Typography>
                                    </Box>
                                </Box>
                            </AccordionSummary>
                            <AccordionDetails>
                                <TableContainer component={Paper} variant="outlined">
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow sx={{ bgcolor: 'action.hover' }}>
                                                <TableCell align="left"><strong>Data</strong></TableCell>
                                                <TableCell align="center"><strong>Qtd Pedidos</strong></TableCell>
                                                <TableCell align="right"><strong>Média ({config?.label})</strong></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {dailyData.map((row) => (
                                                <TableRow key={row.date} hover>
                                                    <TableCell component="th" scope="row" align="left">
                                                        {row.date}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {row.count}
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        <Chip
                                                            label={secondsToTimeString(row.avgTime)}
                                                            size="small"
                                                            color="default"
                                                            variant="outlined"
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </AccordionDetails>
                        </Accordion>
                    )
                })}

                {Object.values(unidadesMap || {}).every(u => getDailyAverages(u.pedidos).length === 0) && (
                    <Box sx={{ p: 2, textAlign: 'center' }}>
                        <Typography variant="body2" color="text.secondary">
                            Sem dados de tempo médio diário para exibir.
                        </Typography>
                    </Box>
                )}
            </Stack>
        </AccordionDetails>
    )
}